import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Box, Button, Flex, Header, OneColumnLayout } from '@electricjs/arc';

import { usePageTitle } from '@/contexts/PageTitleContext';
import NewAssetForm from './NewAssetForm';

const NewAsset = () => {
  const { t } = useTranslation('assets');
  const navigate = useNavigate();
  const titleProps = usePageTitle(t('assetsPage.addAnAsset'));

  return (
    <OneColumnLayout>
      <Header {...titleProps} />
      <Box>
        <Button
          id="back-to-inventory"
          type="button"
          variant="outline"
          iconBefore="arrow-left"
          onClick={() => navigate('/assets')}>
          {t('assetsPage.backToInventory')}
        </Button>
      </Box>
      <Flex vertical alignItems="left" maxWidth="80rem" width="100%">
        <NewAssetForm />
      </Flex>
    </OneColumnLayout>
  );
};

export default NewAsset;
